export default getText => key =>
  ({
    followUp: getText('Follow ups', 'Encounters_Tabs_Header'),
    history: getText('Patient encounter history', 'Encounters_Tabs_Header'),
  }[key])
